// extracted by mini-css-extract-plugin
module.exports = {"page_titles":"service-page-header_page_titles__4G9gA"};